export default {
    topics: [
        {
            title: ' GetMirrorUrl ',
            href: 'sm-eventHisto-GetMirrorUrl.html',
            attributes: { 'data-id': 'sm-eventHisto-GetMirrorUrl' },
            menu: { hasChildren: false },
            tocID: 'sm-eventHisto-GetMirrorUrl-d66e2852',
            topics: [],
        },
        {
            title: ' PushEvent ',
            href: 'sm-eventHisto-PushEvent.html',
            attributes: { 'data-id': 'sm-eventHisto-PushEvent' },
            menu: { hasChildren: false },
            tocID: 'sm-eventHisto-PushEvent-d66e2860',
            topics: [],
        },
        {
            title: ' PushEvents ',
            href: 'sm-eventHisto-PushEvents.html',
            attributes: { 'data-id': 'sm-eventHisto-PushEvents' },
            menu: { hasChildren: false },
            tocID: 'sm-eventHisto-PushEvents-d66e2868',
            topics: [],
        },
    ],
};

